<template>
    <div>
        <div class="row">
            <div class="col-12" v-if="!ready">
                <sau-loading></sau-loading>
            </div>

            <div
                v-for="(service, key) in services"
                :key="service.id"
                class="col-sm-6 col-md-3 mb-6 md:mb-0"
            >
                <div class="d-flex h-100 sau-bx justify-content-center">
                    <div class="align-self-center text-center py-6">
                        <div class="align-self-center">
                            <vue-circle
                                :progress="circleProperties.progress"
                                :size="circleProperties.size"
                                :reverse="false"
                                line-cap="round"
                                :fill="circleProperties.fill"
                                :empty-fill="circleProperties.emptyFill"
                                :animation-start-value="0.0"
                                :start-angle="0"
                                insert-mode="append"
                                :thickness="circleProperties.thickness"
                                :show-percent="false"
                            >
                                <div class="iCountUp">
                                    <ICountUp
                                        :startVal="0"
                                        :endVal="service.count"
                                        :decimals="0"
                                        :duration="countUpProperties.duration"
                                        :options="countUpProperties.options"
                                    />
                                </div>
                            </vue-circle>
                        </div>

                        <div class="sau-menu" v-if="Object.keys(service.services).length">
                            <button class="dropbtn">
                                {{ service.label }}
                                <i class="fa fa-chevron-down" aria-hidden="true"></i>
                            </button>
                            <div
                                class="sau-menu-content dd"
                                v-bind:class="[Object.keys(service.services).length > 5 ? 'sau-menu-content-overflow' : '' ]"
                            >
                                <a
                                    v-for="single in service.services"
                                    :key="single.id"
                                    :href="`/service/${key}/${single.id}`"
                                >{{ single.domain }}</a>
                            </div>
                        </div>
                        <div v-else class="pt-2">
                            <label>{{ service.label }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import ICountUp from 'vue-countup-v2';
import VueCircle from 'vue2-circle-progress';
export default {
    name: 'demo',
    components: {
        ICountUp,
        VueCircle
    },
    mounted() {
        if(! this.hasPermission('products')) {
            return;
        }
        this.getServicesSummary().then((response) => {
                this.ready = true;
                this.services = response.data;
            }
        );
    },
    data() {
        return {
            services: [],
            circleProperties: {
                progress: 100,
                size: 105,
                thickness: 3,
                fill: { color: '#c9c9c9' },
                emptyFill: 'rgba(0, 0, 0, .1)'
            },
            countUpProperties: {
                duration: 6,
                options: {
                    useEasing: true,
                    useGrouping: true,
                    separator: ',',
                    decimal: '.',
                    prefix: '',
                    suffix: ''
                }
            },
            ready: false
        };
    },
    methods: {}
};
</script>

<style scoped>
.iCountUp {
    font-size: 2.8em;
    margin: -5px 0 0 0;
    color: #797979;
}
.sau-menu-content-overflow {
    overflow-y: scroll;
    max-height: 25vh;
}
</style>
